
import React from "react";
import PropTypes from "prop-types";
import Base  from './Base';

import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

const defaultStyle = {
  control: (base, state) => ({ 
    ...base, 
    borderRadius: 0,
    backgroundColor: "#fff",
    borderTopColor: "#b2b2b2",
    boxShadow: "inset 0 2px 1px 0 rgba(0,0,0,.3)",
    height: 40,
  }),
  singleValue: (base, state) => ({
    ...base,
    fontSize: 14,
    fontWeight: "600",
    color: "#666",
    
  })
}

const skin = {
  white: {
    control: (base, state) => ({...base, backgroundColor: "#fff", height: 40, marginBottom: 10, paddingLeft: 10, overFlow: 'hidden' }),
    singleValue: (base, state) => ({ ...base, color: "#666", fontStyle: "italic", overFlow: 'hidden' }),
    groupHeading: (base, state) => ({ ...base, overFlow: 'hidden' }),
  },
  skinWhiteNoRadius: {
    control: (base, state) => ({...base, backgroundColor: "#fff", height: 40, marginBottom: 10, paddingLeft: 10, overFlow: 'hidden', borderRadius: 0 }),
    singleValue: (base, state) => ({ ...base, color: "#666", fontStyle: "italic", overFlow: 'hidden' }),
    groupHeading: (base, state) => ({ ...base, overFlow: 'hidden' }),
  }
};

export default class SelectCustom extends Base {
  
  static propTypes = {
    options: PropTypes.array,
    value: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
    styles: PropTypes.object,
    onChange: PropTypes.func,
    skinWhite: PropTypes.bool,
  }

  static makeSameObject = value => {
    return { value, label: value };
  };
  static makeSameArray = arrayOfValue => arrayOfValue.map(item => ({ value: item, label: item }));
  
  render() {
    const { options, styles, value, skinWhite, skinWhiteNoRadius } = this.props;
    let selectStyle = styles || defaultStyle;
    if (skinWhite === true) selectStyle = skin.white;
    if (skinWhiteNoRadius === true) selectStyle = skin.skinWhiteNoRadius;
    return (
      <Select styles={selectStyle}
        isClearable={true}
        isSearchable={true}
        options={options}
        {...this.props} />
    )
  }

}

export class AsyncSelectCustom extends Base {
  
  static propTypes = {
    options: PropTypes.array,
    value: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
    styles: PropTypes.object,
    onChange: PropTypes.func,
    skinWhite: PropTypes.bool,
  }

  static makeSameObject = value => {
    return { value, label: value };
  };
  static makeSameArray = arrayOfValue => arrayOfValue.map(item => ({ value: item, label: item }));
  
  render() {
    const { options, styles, value, skinWhite, loadOptions, onChange, onInputChange, placeholder } = this.props;
    let selectStyle = styles || defaultStyle;
    if (skinWhite === true) selectStyle = skin.white;
    return (
      <AsyncSelect 
        cacheOptions
        defaultOptions
        styles={selectStyle}
        isClearable={true}
        isSearchable={true}
        options={options}
        loadOptions={loadOptions}
        onInputChange={onInputChange}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
      />
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom/Select.js